import '.js{list-style:none;}.ssr-plugin'
import '.jt{padding-left:0px;}.ssr-plugin'
import '.ju{counter-reset:step-counter;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ee{gap:2rem;}.ssr-plugin'
import { InfoAlert } from '@app/components/core/alert/InfoAlert'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import { styled } from 'inlines'
import { SectionHeader } from '../blocks/SectionHeader'
import { AppearItem, useAppearStyle } from '../blocks/AppearInViewport'

export type StepSectionItem = { content: string; alert?: string }
export type StepSectionType = {
  type: 'steps'
  title: string
  listItems: StepSectionItem[]
}

export const StepsContentSection = ({
  title,
  listItems,
}: StepSectionType & {
  index?: number
}) => {
  return (
    <Column>
      {title && (
        <AppearItem staggerIndex={0}>
          <SectionHeader title={title} />
        </AppearItem>
      )}
      <ol className="js jt ju a b ee"
      >
        {listItems?.map((step, stepIndex) => (
          <StepListItem key={stepIndex} step={step} staggerIndex={stepIndex + 1} />
        ))}
      </ol>
    </Column>
  )
}

const StepListItem = ({
  step,
  staggerIndex,
}: {
  step: StepSectionItem
  staggerIndex: number
}) => {
  const appearStyle = useAppearStyle(staggerIndex)

  return (
    <styled.li
      style={{
        ...appearStyle,
        '&::before': {
          counterIncrement: 'step-counter',
          content: 'counter(step-counter) "."',
          color: 'var(--brand-secondary)',
          fontFamily: 'FunnelDisplay',
          fontWeight: '700',
          fontStyle: 'normal',
          fontSize: '1.75rem',
          lineHeight: '100%',
          paddingRight: '1rem',
        },
      }}
    >
      <Text.Medium style={{ display: 'inline' }}>{step.content}</Text.Medium>
      {step.alert && (
        <InfoAlert message={step.alert} style={{ marginTop: '1rem' }} />
      )}
    </styled.li>
  )
}
